import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Chip } from '@material-ui/core'

import * as DoorAccessActionCreators from '../../actions/doorAccess'

class CommunityAccessChipContainer extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    /* passed props */
    accessId: PropTypes.number.isRequired,
    communityId: PropTypes.number.isRequired,
    /* mapped state */
    doorAccesses: PropTypes.object.isRequired,
    /* mapped dispatch */
    doorAccessActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      doorAccesses: state.doorAccesses,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      doorAccessActions: bindActionCreators(DoorAccessActionCreators, dispatch),
    }
  }

  static styles = (theme) => ({
    chip: {
      margin: theme.spacing(0.5),
    },
  })

  handleClick = (event) => {
    event.stopPropagation()
  }

  handleDelete = (event) => {
    event.stopPropagation()
    this.props.doorAccessActions.removeCommunityDoorAccess(this.props.communityId, this.props.accessId)
  }

  getUser = () => this.props.doorAccesses[this.props.accessId] || {}

  render() {
    return (
      <Chip
        className={this.props.classes.chip}
        clickable={false}
        color={this.getUser().enabled ? 'primary' : 'default'}
        label="Community - wide"
        onClick={this.handleClick}
        onDelete={this.handleDelete}
      />
    )
  }
}

export default connect(
  CommunityAccessChipContainer.mapStateToProps,
  CommunityAccessChipContainer.mapDispatchToProps,
)(withStyles(CommunityAccessChipContainer.styles)(CommunityAccessChipContainer))
